import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';
import { QuizSessionScore } from '@digilize/shared/definitions/src';
import { BehaviorSubject, first, switchMap } from 'rxjs';

@Component({
  selector: 'lsl-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ResultComponent implements OnInit {
  @Input() isExam: boolean;
  @Input() quizSessionScore: QuizSessionScore;
  @Input() replayable: boolean;
  @Output() restartExercise = new EventEmitter<boolean>();
  @Output() continueClick = new EventEmitter<boolean>();
  lessonWasCompletedEarlier = false;
  _newCoursesLoaded = new BehaviorSubject(false);
  constructor(
    private schoolCoursesService: SchoolCoursesService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const lessonId = this.activatedRoute.snapshot.paramMap.get('lessonId');
    this.schoolCoursesService
      .getLesson(lessonId)
      .pipe(
        first(),
        switchMap((lesson) => {
          this.lessonWasCompletedEarlier = lesson.is_completed;

          return this.schoolCoursesService.fetchAndUpdateCourses();
        })
      )
      .subscribe(() => {
        this._newCoursesLoaded.next(true);
      });
  }

  handleRestartExercise() {
    this._newCoursesLoaded.pipe(first((loaded) => loaded)).subscribe((loaded) => {
      if (loaded) {
        this.restartExercise.emit(this.lessonWasCompletedEarlier);
      }
    });
  }

  handleContinueClick() {
    this._newCoursesLoaded.pipe(first((loaded) => loaded)).subscribe((loaded) => {
      if (loaded) {
        this.continueClick.emit(this.lessonWasCompletedEarlier);
      }
    });
  }
}
